import useDefinedContext from "../../../hooks/useDefinedContext";
import DataSubmissionFormContext from "./DataSubmissionFormContext";

const useDataSubmissionFormContext = () => useDefinedContext(DataSubmissionFormContext, "DataSubmissionFormContext");

export default useDataSubmissionFormContext;
